<template>
    <div id="echarts-container">
        <div style="width: 500px;height: 500px" ref="chart1"></div>

        <div>
            <span class="demonstration">默认</span>
            <el-date-picker
                id="dddd"
                v-model="value1"
                type="daterange"
                @change="showTime"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-button @click="clickShow">点击</el-button>
        </div>
        <div>
            <el-table :data="tableData" border style="width: 400px">
                <el-table-column prop="complete" label="解决事件数"></el-table-column>
                <el-table-column prop="total" label="事件总数"></el-table-column>
                <el-table-column prop="completionRate" label="完成率"></el-table-column>
            </el-table>
        </div>
        <div style="width: 500px;height: 500px" ref="chart2"></div>
    </div>
</template>

<script>
    import services from './echarts-eg.service'
    // let echarts=require('echarts')
    export default {
        name: "echarts-eg",
        data(){
            return {
                value1:'',
                graphData:'',
                defaultData:[
                    {value:100, name:'视频广告'},
                    {value:274, name:'联盟广告'},
                    {value:310, name:'邮件营销'},
                    {value:335, name:'直接访问'},
                    {value:400, name:'搜索引擎'}
                ],
                tableData:[]
            }
        },
        created(){
            // this.initCharts();
        },
        mounted(){
            this.initCharts1();
            this.initCharts2(this.graphData);
        },
        components:{

        },
        methods:{
            clickShow(){
                let d=document.getElementById('d')//获取到时间选择器里的input

                d.focus()
            },
            showTime(){
                let vm=this
                console.log(this.value1);
                let params={
                    startTime:this.value1[0],
                    stopTime:this.value1[1]
                }
                services.getEventComplete(params).then(res=>{
                    this.graphData=res.graphData
                    this.tableData=[res.tableData]
                    this.initCharts2(this.graphData);
                })
            },
            initCharts1() {
                let myChart1 = this.$echarts.init(this.$refs.chart1);
                console.log(this.$refs.chart1)
                // 绘制图表
                myChart1.setOption({
                    title: { text: '在Vue中使用echarts' },
                    tooltip: {},
                    xAxis: {
                        data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
                    },
                    yAxis: {},
                    series: [{
                        name: '销量',
                        type: 'bar',
                        data: [5, 20, 36, 10, 10, 20]
                    }]
                });
            },
            initCharts2(graphData) {
                console.log(Boolean(graphData));
                console.log(graphData);
                // console.log(graphData === []);
                let myChart2 = this.$echarts.init(this.$refs.chart2);
                console.log(this.$refs.chart2)
                // 绘制图表
                myChart2.setOption({
                    title: {
                        text: '饼状图eg-1' ,
                        // textAlign:'left',
                        // textVerticalAlign:'middle',
                        // padding: [5, 100]
                    },
                    legend:{
                        type:'plain',
                        bottom:'20'
                    },
                    tooltip:{},
                    // tooltip: {},
                    series: [{
                        name: '访问来源',

                        type: 'pie',
                        radius:'55%',
                        data:!graphData?this.defaultData:graphData,
                        label:{
                            formatter:'{b}:{d}%'
                        }
                    }]
                });
            },

        }
    }

</script>

<style scoped>

</style>
